import { addDays, format, subDays } from 'date-fns'

import { Reservation } from '@monorepo/functions/src/types/reservations'
import { AdditionalService, DriverService, HairdressingService } from '@monorepo/functions/src/types/services'

// Example reservations that will be managed in the context
export const EXAMPLE_RESERVATIONS_LOCAL: Reservation[] = [
    {
        id: 'EXAMPLE_HAIRSALON_1',
        type: 'peluqueria',
        source: 'hotel',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_1',
            name: 'John Smith',
            phone: '666555444',
            email: 'john@example.com',
        },
        pet: {
            id: 'PET_1',
            name: 'Buddy',
            breed: 'Golden Retriever',
            size: 'grande',
            weight: 30,
            sex: 'M',
            isNeutered: true,
            roomNumber: 'HAB.1',
            personality: 'Amigable y juguetón',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush', 'deshedding'],
            } satisfies HairdressingService,
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'dropoff',
                dropoffPrice: 25,
                price: 25,
            } satisfies DriverService,
        ],
        status: 'pending',
        totalPrice: 75,
        paymentStatus: 'Pendiente',
        observations: 'Cliente del hotel - Habitación HAB.1',
        hotelCheckIn: format(new Date(), 'yyyy-MM-dd'),
        hotelCheckOut: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        hotelCheckOutTime: '12:00',
        tasks: [
            {
                id: 'task1',
                reservationId: 'EXAMPLE_HAIRSALON_1',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['bath_and_brush'],
                },
                date: format(new Date(), 'yyyy-MM-dd'),
                time: '10:00',
                duration: 30,
            },
            {
                id: 'task2',
                reservationId: 'EXAMPLE_HAIRSALON_1',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['deshedding'],
                },
                date: format(new Date(), 'yyyy-MM-dd'),
                time: '10:30',
                duration: 30,
            },
        ],
    },
    {
        id: 'EXAMPLE_HAIRSALON_2',
        type: 'peluqueria',
        source: 'hotel',
        date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_2',
            name: 'Alice Johnson',
            phone: '+34666777888',
            email: 'alice@example.com',
        },
        pet: {
            id: 'PET_2',
            name: 'Daisy',
            breed: 'Poodle',
            size: 'pequeño',
            weight: 5,
            sex: 'F',
            isNeutered: true,
            roomNumber: 'HAB.2',
            personality: 'Cariñosa y tranquila',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa'],
            } satisfies HairdressingService,
        ],
        status: 'pending',
        totalPrice: 65,
        paymentStatus: 'Pendiente',
        observations: 'Cliente del hotel - Habitación HAB.2',
        hotelCheckIn: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        hotelCheckOut: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        hotelCheckOutTime: '14:00',
        tasks: [
            {
                id: 'task3',
                reservationId: 'EXAMPLE_HAIRSALON_2',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['bath_and_trim'],
                },
                date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
                time: '11:00',
                duration: 30,
            },
            {
                id: 'task4',
                reservationId: 'EXAMPLE_HAIRSALON_2',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['spa'],
                },
                date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
                time: '11:30',
                duration: 30,
            },
        ],
    },
    {
        id: 'EXAMPLE_HAIRSALON_3',
        type: 'peluqueria',
        source: 'hotel',
        date: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        time: '11:30',
        client: {
            id: 'EXAMPLE_CLIENT_3',
            name: 'Carlos Rodriguez',
            phone: '666999000',
            email: 'carlos@example.com',
        },
        pet: {
            id: 'PET_3',
            name: 'Shadow',
            breed: 'Husky',
            size: 'grande',
            weight: 28,
            sex: 'M',
            isNeutered: true,
            roomNumber: 'HAB.3',
            personality: 'Independiente y aventurera',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush', 'deshedding', 'spa_ozone'],
            },
        ],
        status: 'pending',
        totalPrice: 90,
        paymentStatus: 'Pendiente',
        observations: 'Cliente del hotel - Habitación HAB.3',
        tasks: [
            {
                id: 'task5',
                reservationId: 'EXAMPLE_HAIRSALON_3',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['bath_and_brush'],
                },
                date: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
                time: '11:30',
                duration: 30,
            },
            {
                id: 'task6',
                reservationId: 'EXAMPLE_HAIRSALON_3',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['deshedding'],
                },
                date: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
                time: '12:00',
                duration: 30,
            },
            {
                id: 'task7',
                reservationId: 'EXAMPLE_HAIRSALON_3',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['spa_ozone'],
                },
                date: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
                time: '12:30',
                duration: 30,
            },
        ],
    },
    // Check-in today - 3 pets
    {
        id: 'EXAMPLE_CHECKIN_1',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '10:00',
        checkOutDate: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_4',
            name: 'Emma Wilson',
            phone: '666555444',
            email: 'emma@example.com',
        },
        pets: [
            {
                name: 'Cooper',
                breed: 'Golden Retriever',
                weight: 30,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.4',
                personality: 'Amigable y juguetón',
            },
            {
                name: 'Bailey',
                breed: 'Beagle',
                weight: 12,
                size: 'mediano',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.5',
                personality: 'Sociable y activa',
            },
            {
                name: 'Oliver',
                breed: 'Yorkshire',
                weight: 3,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.6',
                personality: 'Dulce y sociable',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
        ],
        status: 'confirmed',
        totalPrice: 300,
        paymentStatus: 'Pagado',
    },
    // Check-in today - 2 pets
    {
        id: 'EXAMPLE_CHECKIN_2',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '12:00',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_5',
            name: 'David Brown',
            phone: '+34666777888',
            email: 'david@example.com',
        },
        pets: [
            {
                name: 'Mia',
                breed: 'Labrador',
                weight: 25,
                size: 'grande',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.7',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Leo',
                breed: 'French Bulldog',
                weight: 12,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.8',
                personality: 'Inteligente y enérgico',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesita cuidados especiales',
            },
        ],
        status: 'confirmed',
        totalPrice: 500,
        paymentStatus: 'Pendiente',
    },
    // Check-in tomorrow - 3 pets
    {
        id: 'EXAMPLE_CHECKIN_3',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(addDays(new Date(), 4), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_6',
            name: 'Sophie Martinez',
            phone: '666999000',
            email: 'sophie@example.com',
        },
        pets: [
            {
                name: 'Zeus',
                breed: 'German Shepherd',
                weight: 35,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.9',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Atlas',
                breed: 'Border Collie',
                weight: 20,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.10',
                personality: 'Inteligente y enérgico',
            },
            {
                name: 'Nova',
                breed: 'Poodle',
                weight: 5,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.11',
                personality: 'Cariñosa y tranquila',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesita cuidados especiales',
            },
        ],
        status: 'pending',
        totalPrice: 600,
        paymentStatus: 'Pendiente',
    },
    // Check-out today - 2 pets
    {
        id: 'EXAMPLE_CHECKOUT_1',
        type: 'hotel',
        checkInDate: format(subDays(new Date(), 3), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(new Date(), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_7',
            name: 'Isabella Taylor',
            phone: '666111222',
            email: 'isabella@example.com',
        },
        pets: [
            {
                name: 'Willow',
                breed: 'Poodle',
                weight: 8,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.12',
                personality: 'Amigable y juguetón',
            },
            {
                name: 'Duke',
                breed: 'Schnauzer',
                weight: 15,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.13',
                personality: 'Protector y territorial',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesita cuidados especiales',
            },
        ],
        status: 'confirmed',
        totalPrice: 400,
        paymentStatus: 'Pagado',
    },
    // Check-out today - 3 pets
    {
        id: 'EXAMPLE_CHECKOUT_2',
        type: 'hotel',
        checkInDate: format(subDays(new Date(), 5), 'yyyy-MM-dd'),
        checkInTime: '16:00',
        checkOutDate: format(new Date(), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_8',
            name: 'Lucas Anderson',
            phone: '666333444',
            email: 'lucas@example.com',
        },
        pets: [
            {
                name: 'Bear',
                breed: 'Husky',
                weight: 28,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.14',
                personality: 'Independiente y aventurera',
            },
            {
                name: 'Lily',
                breed: 'Cocker Spaniel',
                weight: 13,
                size: 'mediano',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.15',
                personality: 'Sociable y activa',
            },
            {
                name: 'Ziggy',
                breed: 'Jack Russell',
                weight: 6,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.16',
                personality: 'Dulce y sociable',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
        ],
        status: 'confirmed',
        totalPrice: 700,
        paymentStatus: 'Pagado',
    },
    // Check-out today - 2 pets with driver service
    {
        id: 'EXAMPLE_CHECKOUT_3',
        type: 'hotel',
        checkInDate: format(subDays(new Date(), 2), 'yyyy-MM-dd'),
        checkInTime: '15:00',
        checkOutDate: format(new Date(), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_9',
            name: 'Elena Garcia',
            phone: '666444555',
            email: 'elena@example.com',
        },
        pets: [
            {
                name: 'Finn',
                breed: 'Shih Tzu',
                weight: 5,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.17',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Chloe',
                breed: 'Maltese',
                weight: 4,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.18',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'dropoff',
                dropoffPrice: 30,
                price: 30,
            } as AdditionalService,
        ],
        status: 'confirmed',
        totalPrice: 350,
        paymentStatus: 'Pendiente',
    },
    // External reservations
    {
        id: 'EXAMPLE_EXTERNAL_1',
        type: 'peluqueria',
        source: 'external',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_10',
            name: 'Victoria Ruiz',
            phone: '666111222',
            email: 'victoria@example.com',
        },
        pet: {
            id: 'PET_4',
            name: 'Molly',
            breed: 'Yorkshire Terrier',
            size: 'pequeño',
            weight: 3,
            sex: 'F',
            isNeutered: true,
            roomNumber: 'HAB.19',
            personality: 'Amigable y juguetón',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim'],
            } satisfies HairdressingService,
        ],
        status: 'pending',
        totalPrice: 45,
        paymentStatus: 'Pendiente',
        observations: 'Primera visita',
        requestedTime: '10:00',
        tasks: [
            {
                id: 'task8',
                reservationId: 'EXAMPLE_EXTERNAL_1',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['bath_and_trim'],
                },
                date: format(new Date(), 'yyyy-MM-dd'),
                time: '10:00',
                duration: 45,
            },
        ],
    },
    {
        id: 'EXAMPLE_EXTERNAL_2',
        type: 'peluqueria',
        source: 'external',
        date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_11',
            name: 'Marco Fernandez',
            phone: '666333444',
            email: 'marco@example.com',
        },
        pet: {
            id: 'PET_5',
            name: 'Bruno',
            breed: 'Bulldog Francés',
            size: 'mediano',
            weight: 12,
            sex: 'M',
            isNeutered: true,
            roomNumber: 'HAB.20',
            personality: 'Protector y territorial',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush', 'spa'],
            } satisfies HairdressingService,
        ],
        status: 'pending',
        totalPrice: 60,
        paymentStatus: 'Pendiente',
        observations: 'Cliente habitual',
        requestedTime: '16:30',
        tasks: [
            {
                id: 'task9',
                reservationId: 'EXAMPLE_EXTERNAL_2',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['bath_and_brush'],
                },
                date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
                time: '16:30',
                duration: 30,
            },
            {
                id: 'task10',
                reservationId: 'EXAMPLE_EXTERNAL_2',
                service: {
                    type: 'hairdressing',
                    petIndex: 0,
                    services: ['spa'],
                },
                date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
                time: '17:00',
                duration: 30,
            },
        ],
    },
    // Active reservations with different transport services
    {
        id: 'EXAMPLE_ACTIVE_1',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_12',
            name: 'Gabriel Torres',
            phone: '+34666777888',
            email: 'gabriel@example.com',
        },
        pets: [
            {
                name: 'Storm',
                breed: 'German Shepherd',
                weight: 35,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.21',
                personality: 'Alerta y territorial',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'pickup',
                pickupPrice: 25,
                price: 25,
            } as AdditionalService,
        ],
        status: 'confirmed',
        totalPrice: 400,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_ACTIVE_2',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '15:00',
        checkOutDate: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_13',
            name: 'Lucia Morales',
            phone: '666999000',
            email: 'lucia@example.com',
        },
        pets: [
            {
                name: 'River',
                breed: 'Husky',
                weight: 28,
                size: 'grande',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.22',
                personality: 'Independiente y aventurera',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'dropoff',
                dropoffPrice: 30,
                price: 30,
            } as AdditionalService,
        ],
        status: 'confirmed',
        totalPrice: 350,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_ACTIVE_3',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '16:00',
        checkOutDate: format(addDays(new Date(), 4), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_14',
            name: 'Adrian Navarro',
            phone: '666444333',
            email: 'adrian@example.com',
        },
        pets: [
            {
                name: 'Phoenix',
                breed: 'Golden Retriever',
                weight: 32,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.23',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
                pickupPrice: 25,
                dropoffPrice: 30,
                price: 55,
            } as AdditionalService,
        ],
        status: 'confirmed',
        totalPrice: 450,
        paymentStatus: 'Pendiente',
    },
    // Ejemplos de guardería (mismo día de check-in y check-out)
    {
        id: 'EXAMPLE_DAYCARE_1',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '09:00',
        checkOutDate: format(new Date(), 'yyyy-MM-dd'),
        checkOutTime: '19:00',
        client: {
            id: 'EXAMPLE_CLIENT_15',
            name: 'Diana Jimenez',
            phone: '666123456',
            email: 'diana@example.com',
        },
        pets: [
            {
                name: 'Echo',
                breed: 'French Bulldog',
                weight: 12,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.24',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesita supervisión constante',
            },
        ],
        status: 'confirmed',
        totalPrice: 25,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_DAYCARE_2',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        checkInTime: '08:00',
        checkOutDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        checkOutTime: '20:00',
        client: {
            id: 'EXAMPLE_CLIENT_16',
            name: 'Roberto Herrera',
            phone: '666234567',
            email: 'roberto@example.com',
        },
        pets: [
            {
                name: 'Sage',
                breed: 'Poodle',
                weight: 5,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.25',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            } as AdditionalService,
        ],
        status: 'confirmed',
        totalPrice: 35,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_DAYCARE_3',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        checkInTime: '10:00',
        checkOutDate: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        checkOutTime: '18:00',
        client: {
            id: 'EXAMPLE_CLIENT_17',
            name: 'Raquel Ortiz',
            phone: '666345678',
            email: 'raquel@example.com',
        },
        pets: [
            {
                name: 'Scout',
                breed: 'Beagle',
                weight: 15,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.26',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Raven',
                breed: 'Beagle',
                weight: 14,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.27',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_food',
                petIndex: 1,
                foodType: 'refrigerated',
            },
        ],
        status: 'confirmed',
        totalPrice: 50,
        paymentStatus: 'Pendiente',
    },
    // Reserva pendiente de hotel 1
    {
        id: 'EXAMPLE_PENDING_HOTEL_1',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(addDays(new Date(), 8), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_PENDING_1',
            name: 'Marina Lopez',
            phone: '666111222',
            email: 'marina@example.com',
        },
        pets: [
            {
                name: 'Winter',
                breed: 'Cavalier King Charles',
                weight: 8,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.28',
                personality: 'Dulce y sociable',
            },
            {
                name: 'Jasper',
                breed: 'Cavalier King Charles',
                weight: 9,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.29',
                personality: 'Tranquilo y cariñoso',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
        ],
        status: 'pending',
        totalPrice: 240,
        paymentStatus: 'Pendiente',
    },
    // Reserva pendiente de hotel 2
    {
        id: 'EXAMPLE_PENDING_HOTEL_2',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        checkInTime: '12:00',
        checkOutDate: format(addDays(new Date(), 7), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_PENDING_2',
            name: 'Hugo Diaz',
            phone: '666333444',
            email: 'hugo@example.com',
        },
        pets: [
            {
                name: 'Onyx',
                breed: 'Maine Coon',
                weight: 7,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.30',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Pearl',
                breed: 'Siamese',
                weight: 4,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.31',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Ash',
                breed: 'Persian',
                weight: 5,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.32',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Medicación diaria',
            },
        ],
        status: 'pending',
        totalPrice: 400,
        paymentStatus: 'Pendiente',
    },
    // Reserva pendiente de hotel 3
    {
        id: 'EXAMPLE_PENDING_HOTEL_3',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        checkInTime: '12:00',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_PENDING_3',
            name: 'Carla Vega',
            phone: '666555666',
            email: 'ana@example.com',
        },
        pets: [
            {
                name: 'Milo',
                breed: 'Shih Tzu',
                weight: 5,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.33',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Lola',
                breed: 'Shih Tzu',
                weight: 4,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.34',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
        ],
        status: 'pending',
        totalPrice: 320,
        paymentStatus: 'Pendiente',
    },
    // Presupuestos de hotel
    {
        id: 'EXAMPLE_BUDGET_1',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 10), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(addDays(new Date(), 15), 'yyyy-MM-dd'),
        checkOutTime: '12:00',
        client: {
            id: 'EXAMPLE_CLIENT_BUDGET_1',
            name: 'Laura Presupuesto',
            phone: '666777999',
            email: 'laura.p@example.com',
        },
        pets: [
            {
                name: 'Coco',
                breed: 'Labrador',
                weight: 30,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.1',
                personality: 'Amigable y juguetón',
            },
            {
                name: 'Luna',
                breed: 'Labrador',
                weight: 28,
                size: 'grande',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.2',
                personality: 'Sociable y activa',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush', 'deshedding'],
            },
            {
                type: 'hairdressing',
                petIndex: 1,
                services: ['bath_and_brush', 'deshedding'],
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
        ],
        status: 'budget',
        totalPrice: 750,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_BUDGET_2',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 15), 'yyyy-MM-dd'),
        checkInTime: '12:00',
        checkOutDate: format(addDays(new Date(), 20), 'yyyy-MM-dd'),
        checkOutTime: '12:00',
        client: {
            id: 'EXAMPLE_CLIENT_BUDGET_2',
            name: 'Carlos Presupuesto',
            phone: '666888000',
            email: 'carlos.p@example.com',
        },
        pets: [
            {
                name: 'Rocky',
                breed: 'German Shepherd',
                weight: 35,
                size: 'grande',
                sex: 'M',
                isNeutered: false,
                roomNumber: 'HAB.5',
                personality: 'Protector y territorial',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'medication',
                petIndex: 0,
                comment: 'Medicación diaria para las articulaciones',
                frequency: 'multiple',
            },
        ],
        status: 'budget',
        totalPrice: 500,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_BUDGET_3',
        type: 'hotel',
        checkInDate: format(addDays(new Date(), 20), 'yyyy-MM-dd'),
        checkInTime: '15:00',
        checkOutDate: format(addDays(new Date(), 23), 'yyyy-MM-dd'),
        checkOutTime: '11:00',
        client: {
            id: 'EXAMPLE_CLIENT_BUDGET_3',
            name: 'Ana Presupuesto',
            phone: '666999111',
            email: 'ana.p@example.com',
        },
        pets: [
            {
                name: 'Bella',
                breed: 'Yorkshire',
                weight: 3,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.5',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Max',
                breed: 'Yorkshire',
                weight: 3.5,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.6',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Nina',
                breed: 'Yorkshire',
                weight: 2.8,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.7',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa'],
            },
            {
                type: 'hairdressing',
                petIndex: 1,
                services: ['bath_and_trim', 'spa'],
            },
            {
                type: 'hairdressing',
                petIndex: 2,
                services: ['bath_and_trim', 'spa'],
            },
        ],
        status: 'budget',
        totalPrice: 450,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_UNSCHEDULED_1',
        type: 'peluqueria',
        source: 'hotel',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_10',
            name: 'Pedro Gómez',
            phone: '611222333',
            email: 'pedro@example.com',
        },
        pet: {
            id: 'PET_10',
            name: 'Nala',
            breed: 'Pastor Alemán',
            size: 'grande',
            weight: 30,
            sex: 'F',
            isNeutered: true,
            roomNumber: 'HAB.8',
            personality: 'Protector, leal y juguetón',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['deshedding', 'bath_and_brush'],
            } satisfies HairdressingService,
        ],
        status: 'confirmed',
        observations: 'Cliente habitual',
        totalPrice: 50,
        paymentStatus: 'pending',
        hotelCheckIn: format(new Date(), 'yyyy-MM-dd'),
        hotelCheckOut: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        hotelCheckOutTime: '12:00',
    },
    {
        id: 'EXAMPLE_UNSCHEDULED_2',
        type: 'peluqueria',
        source: 'external',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: '',
        client: {
            id: 'EXAMPLE_CLIENT_11',
            name: 'Carmen Rodríguez',
            phone: '644555666',
            email: 'carmen@example.com',
        },
        pet: {
            id: 'PET_11',
            name: 'Coco',
            breed: 'Bulldog Francés',
            size: 'mediano',
            weight: 12,
            sex: 'M',
            isNeutered: true,
            roomNumber: 'HAB.9',
            personality: 'Protector, leal y juguetón',
        },
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa'],
            } satisfies HairdressingService,
        ],
        status: 'confirmed',
        totalPrice: 40,
        paymentStatus: 'pending',
        requestedTime: '16:00',
    },
    // Additional check-ins for today
    {
        id: 'EXAMPLE_CHECKIN_TODAY_1',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '10:00',
        checkOutDate: format(addDays(new Date(), 4), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_1',
            name: 'Paula Sánchez',
            phone: '677111222',
            email: 'paula@example.com',
        },
        pets: [
            {
                name: 'Thor',
                breed: 'Rottweiler',
                weight: 45,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.1',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
        ],
        status: 'confirmed',
        totalPrice: 450,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_2',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '11:00',
        checkOutDate: format(addDays(new Date(), 7), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_2',
            name: 'Miguel Ángel Pérez',
            phone: '677333444',
            email: 'miguel@example.com',
        },
        pets: [
            {
                name: 'Simba',
                breed: 'Maine Coon',
                weight: 8,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.2',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Nala',
                breed: 'Maine Coon',
                weight: 6,
                size: 'mediano',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.3',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Medicación diaria para el pelo',
            },
        ],
        status: 'confirmed',
        totalPrice: 560,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_3',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '12:00',
        checkOutDate: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_3',
            name: 'Sara López',
            phone: '677555666',
            email: 'sara@example.com',
        },
        pets: [
            {
                name: 'Toby',
                breed: 'Chihuahua',
                weight: 2,
                size: 'pequeño',
                sex: 'M',
                isNeutered: false,
                roomNumber: 'HAB.4',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Luna',
                breed: 'Chihuahua',
                weight: 1.8,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.5',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Rocky',
                breed: 'Chihuahua',
                weight: 2.1,
                size: 'pequeño',
                sex: 'M',
                isNeutered: false,
                roomNumber: 'HAB.6',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa'],
            },
            {
                type: 'hairdressing',
                petIndex: 1,
                services: ['bath_and_trim', 'spa'],
            },
            {
                type: 'hairdressing',
                petIndex: 2,
                services: ['bath_and_trim', 'spa'],
            },
        ],
        status: 'confirmed',
        totalPrice: 380,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_4',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '13:00',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_4',
            name: 'Antonio Martínez',
            phone: '677777888',
            email: 'antonio@example.com',
        },
        pets: [
            {
                name: 'Max',
                breed: 'Doberman',
                weight: 35,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.7',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesita ejercicio diario',
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'dropoff',
            },
        ],
        status: 'confirmed',
        totalPrice: 420,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_5',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '14:00',
        checkOutDate: format(addDays(new Date(), 10), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_5',
            name: 'Carmen García',
            phone: '677999000',
            email: 'carmen@example.com',
        },
        pets: [
            {
                name: 'Lola',
                breed: 'Cocker Spaniel',
                weight: 12,
                size: 'mediano',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.10',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush', 'deshedding', 'spa'],
            },
        ],
        status: 'confirmed',
        totalPrice: 750,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_6',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '15:00',
        checkOutDate: format(addDays(new Date(), 4), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_6',
            name: 'Roberto Fernández',
            phone: '677112233',
            email: 'roberto@example.com',
        },
        pets: [
            {
                name: 'Nina',
                breed: 'Border Collie',
                weight: 18,
                size: 'mediano',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.11',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Rex',
                breed: 'Border Collie',
                weight: 20,
                size: 'mediano',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.12',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Necesitan mucha actividad física',
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
        ],
        status: 'confirmed',
        totalPrice: 480,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_7',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '16:00',
        checkOutDate: format(addDays(new Date(), 6), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_7',
            name: 'Laura Ruiz',
            phone: '677445566',
            email: 'laura@example.com',
        },
        pets: [
            {
                name: 'Coco',
                breed: 'Pomeranian',
                weight: 3,
                size: 'pequeño',
                sex: 'M',
                isNeutered: false,
                roomNumber: 'HAB.13',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa_ozone'],
            },
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
        ],
        status: 'confirmed',
        totalPrice: 520,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_8',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '17:00',
        checkOutDate: format(addDays(new Date(), 8), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_8',
            name: 'Diego Torres',
            phone: '677778899',
            email: 'diego@example.com',
        },
        pets: [
            {
                name: 'Zeus',
                breed: 'Bullmastiff',
                weight: 50,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.14',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Dieta especial y ejercicio moderado',
            },
        ],
        status: 'confirmed',
        totalPrice: 640,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_9',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '09:00',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_9',
            name: 'María José Navarro',
            phone: '677001122',
            email: 'mariajose@example.com',
        },
        pets: [
            {
                name: 'Milo',
                breed: 'Dachshund',
                weight: 7,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.15',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Bella',
                breed: 'Dachshund',
                weight: 6,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.16',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_brush'],
            },
            {
                type: 'hairdressing',
                petIndex: 1,
                services: ['bath_and_brush'],
            },
        ],
        status: 'confirmed',
        totalPrice: 450,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_10',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '10:30',
        checkOutDate: format(addDays(new Date(), 7), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_10',
            name: 'Francisco Moreno',
            phone: '677334455',
            email: 'francisco@example.com',
        },
        pets: [
            {
                name: 'Rocky',
                breed: 'Boxer',
                weight: 30,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.17',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Ejercicio diario necesario',
            },
        ],
        status: 'confirmed',
        totalPrice: 580,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_11',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '11:30',
        checkOutDate: format(addDays(new Date(), 4), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_11',
            name: 'Isabel Romero',
            phone: '677667788',
            email: 'isabel@example.com',
        },
        pets: [
            {
                name: 'Luna',
                breed: 'Persian Cat',
                weight: 4,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.18',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Sol',
                breed: 'Persian Cat',
                weight: 4.5,
                size: 'pequeño',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.19',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_food',
                petIndex: 1,
                foodType: 'refrigerated',
            },
        ],
        status: 'confirmed',
        totalPrice: 360,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_12',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '12:30',
        checkOutDate: format(addDays(new Date(), 6), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_12',
            name: 'Javier Molina',
            phone: '677889900',
            email: 'javier@example.com',
        },
        pets: [
            {
                name: 'Kira',
                breed: 'Belgian Malinois',
                weight: 28,
                size: 'grande',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.20',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Entrenamiento diario requerido',
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'pickup',
            },
        ],
        status: 'confirmed',
        totalPrice: 490,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_13',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '13:30',
        checkOutDate: format(addDays(new Date(), 5), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_13',
            name: 'Ana Belén Soto',
            phone: '677112233',
            email: 'anabelen@example.com',
        },
        pets: [
            {
                name: 'Nube',
                breed: 'Bichon Frise',
                weight: 5,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.12',
                personality: 'Protector, leal y juguetón',
            },
            {
                name: 'Cielo',
                breed: 'Bichon Frise',
                weight: 4.5,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.13',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'hairdressing',
                petIndex: 0,
                services: ['bath_and_trim', 'spa'],
            },
            {
                type: 'hairdressing',
                petIndex: 1,
                services: ['bath_and_trim', 'spa'],
            },
        ],
        status: 'confirmed',
        totalPrice: 440,
        paymentStatus: 'Pendiente',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_14',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '14:30',
        checkOutDate: format(addDays(new Date(), 9), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_14',
            name: 'Raúl Jiménez',
            phone: '677445566',
            email: 'raul@example.com',
        },
        pets: [
            {
                name: 'Titan',
                breed: 'Saint Bernard',
                weight: 65,
                size: 'grande',
                sex: 'M',
                isNeutered: true,
                roomNumber: 'HAB.15',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'special_care',
                petIndex: 0,
                comment: 'Control de temperatura necesario',
            },
        ],
        status: 'confirmed',
        totalPrice: 720,
        paymentStatus: 'Pagado',
    },
    {
        id: 'EXAMPLE_CHECKIN_TODAY_15',
        type: 'hotel',
        checkInDate: format(new Date(), 'yyyy-MM-dd'),
        checkInTime: '15:30',
        checkOutDate: format(addDays(new Date(), 3), 'yyyy-MM-dd'),
        client: {
            id: 'EXAMPLE_CLIENT_TODAY_15',
            name: 'Lucía Vargas',
            phone: '677998877',
            email: 'lucia@example.com',
        },
        pets: [
            {
                name: 'Pelusa',
                breed: 'Ragdoll',
                weight: 5,
                size: 'pequeño',
                sex: 'F',
                isNeutered: true,
                roomNumber: 'HAB.16',
                personality: 'Protector, leal y juguetón',
            },
        ],
        additionalServices: [
            {
                type: 'special_food',
                petIndex: 0,
                foodType: 'refrigerated',
            },
            {
                type: 'driver',
                petIndex: 0,
                serviceType: 'both',
            },
        ],
        status: 'confirmed',
        totalPrice: 280,
        paymentStatus: 'Pendiente',
    },
]

export const EXAMPLE_RESERVATIONS = window.location.hostname === 'localhost' ? [] : []
